<div *ngIf="appSuccess && !appError" class="ontario-row" aria-live="polite" aria-atomic="true" id="pageLevelMessageId"
  #pageMsg>
  <div class="ontario-columns ontario-small-12">

    <div class="ontario-alert ontario-alert--success">
      <div class="ontario-alert__header">
        <div class="ontario-alert__header-icon">
          <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
            <use href="#ontario-icon-alert-success"></use>
          </svg>
        </div>
        <h2 class="ontario-alert__header-title ontario-h4">{{'bss.success' | translate}}:</h2>
      </div>
      <div class="ontario-alert__body">
        <p [innerHTML]="appSuccessMessage | translate"></p>
      </div>
    </div>
  </div>
</div>

<div tabindex="101" *ngIf="appError" class="ontario-row" aria-live="polite" aria-atomic="true" id="pageLevelMessageId"
  id="pageLevelMessageId" #pageMsg>
  <div class="ontario-columns">
    <div class="ontario-alert ontario-alert--error">
      <div class="ontario-alert__header">
        <div class="ontario-alert__header-icon">
          <svg class="ontario-icon" alt="Error" aria-hidden="true" focusable="false" sol:category="primary"
            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
            <use href="#ontario-icon-alert-error"></use>
          </svg>
        </div>
        <h2 class="ontario-alert__header-title ontario-h4">
          {{ "bss.error" | translate }}
        </h2>
      </div>
      <div class="ontario-alert__body">
        <p [innerHTML]="appErrorMessage | translate">
      </div>
    </div>
  </div>
</div>

<div class="ontario-row">
  <div class="ontario-column ontario-small-12">
    <input type="hidden" name="menuType" id="menuType" value="public" />
    <h2 id="pageTitle"> {{ 'bss.admin.manageUserEmailAccess.title' | translate }}</h2>
    <hr>
    <div [innerHTML]="'bss.admin.manageUserEmailAccess.content.scenarios' | translate"></div>
    <div>
      <ul>
        <li>
          {{'bss.admin.manageUserEmailAccess.content.scenarios.1' | translate}}
        </li>
        <li>
          {{'bss.admin.manageUserEmailAccess.content.scenarios.2'| translate}}
        </li>
      </ul>
    </div>
    <p [innerHTML]="'bss.admin.manageUserEmailAccess.content.instruction' | translate"></p>
    <button tabindex="102" (click)="onCancel()" class="ontario-button ontario-button--primary"
      title="{{ 'bss.admin.manageUserEmailAccess.button.back.title' | translate }}">
      {{ 'bss.admin.manageUserEmailAccess.button.back' | translate }}
    </button>
    <button tabindex="101" (click)="onLost()" class="ontario-button ontario-button--secondary" aria-describedby="pageLevelMessageId"
      title="{{ 'bss.admin.manageUserEmailAccess.button.lost.title' | translate }}">
      {{ 'bss.admin.manageUserEmailAccess.button.lost' | translate }}
    </button>
    <button tabindex="101" (click)="onRestore()" class="ontario-button ontario-button--primary" aria-describedby="pageLevelMessageId"
      title="{{ 'bss.admin.manageUserEmailAccess.button.restore.title' | translate }}">
      {{ 'bss.admin.manageUserEmailAccess.button.restore' | translate }}
    </button>
  </div>
</div>

<dialog class="ontario-progress" #progressDialog>
  <app-progress></app-progress>
</dialog>